import { ResponsiveDialog } from '@/components/responsiveDialog/ResponsiveDialog';
import { Box, Button, DialogActions, DialogContent, Typography } from '@montugroup/design-system';

export const DispenseIntervalDialog = ({
  dialogOpen,
  handleCloseDialog,
}: {
  dialogOpen: boolean;
  handleCloseDialog: () => void;
}) => {
  return (
    <ResponsiveDialog
      open={dialogOpen}
      onClose={handleCloseDialog}
      title={
        <Box component="span" fontWeight={600}>
          What you need to know
        </Box>
      }
      closeButton={true}
      fullWidth
      maxWidth="sm"
      aria-labelledby="dispense-interval-dialog-title"
    >
      <DialogContent>
        <Typography variant="body1">
          You can&apos;t refill some of your medication due to <strong>Dispense Interval</strong> lock. It refers to the
          period of time you need to wait between making orders according to medical dispensing regulations.
        </Typography>
        <br />
        <Typography variant="body1">What does this mean?</Typography>

        <Box component="ul" sx={{ mt: 0, pl: (theme) => theme.spacing(10) }}>
          <Box component="li">
            <Typography variant="body1">
              <strong>Making orders:</strong> if you&apos;re happy to wait, proceed with your order and we&apos;ll
              process it when the dispense interval time ends.
            </Typography>
          </Box>
          <Box component="li">
            <Typography variant="body1">
              <strong>Other medication:</strong> you can unselect the medication on Dispense Interval from your order if
              you need other medications sooner.
            </Typography>
          </Box>
        </Box>
        <Typography variant="body1">
          If you want to find out more about how dispense interval works, select <strong>Learn more</strong>.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="primary" onClick={handleCloseDialog}>
          Return to order
        </Button>
        <Button
          href="https://support.umeds.com.au/hc/en-au/articles/36042289572377-Understanding-prescriptions#h_01J9031XWSCJ1GAZ9DV91B9PCP"
          variant="contained"
          color="primary"
          {...{ target: '_blank' }}
        >
          Learn more
        </Button>
      </DialogActions>
    </ResponsiveDialog>
  );
};
